import {ContactTypeFilterView} from "../../../../types/ContactTypeFilter";
import {useEffect, useState} from "react";
import {ContactView} from "../../../../types/Contact";
import ContactWidget from "./ContactWidget";
import {Spinner} from "react-bootstrap";
import {useRestClient} from "../../../../client/SpmRestClient";
import {useAlerts} from "../../../../utils/UserAlerts";

interface ContactTypeFilterProps {
	filter: ContactTypeFilterView;
	regionId: number;
}

export default function ContactTypeFilter({filter, regionId}: ContactTypeFilterProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [contacts, setContacts] = useState<Array<ContactView>>();

	useEffect(
		() => {
			setContacts(undefined);
			restClient.contacts
				.filtered(
					regionId,
					filter.sourceId,
					filter.contactTypeId,
					filter.targetGroups,
					null,
					{page: 0, size: 10}
				)
				.then((p) => setContacts(p.content))
				.catch((e) => userAlerts.err(e));
		},
		[regionId, filter]
	);

	if (!contacts) return <Spinner/>

	return (
		<div>
			<h5>{filter.contactTypeName}</h5>
			{
				(contacts.length === 0) ? <p className="small">Nepodařilo se nalézt žádné kontakty.</p>
					: contacts.map((contact, index) => <ContactWidget key={index} contact={contact}/>)
			}
		</div>
	);
}
